module.exports = __webpack_public_path__ + "static/media/Legs-&-Abs.240b2f3d.jpeg";